import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Payment } from 'types/Payment';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import ProfileAvatar from 'components/ProfileAvatar/ProfileAvatar';
import Status from 'common/components/Status/Status';
import dayjs from 'dayjs';
import ProfileBadges from 'components/ProfileBadges/ProfileBadges';
import Icon from 'components/Icon/Icon';

function PaymentItem({ item }: { item: Payment }) {
  const { t } = useTranslation();

  const editLink = `/payments/${item.id}`;

  return (
    <div className="responsive-flex-lg px-4 py-4 mt-2 w-full relative bg-white cursor-pointer rounded-lg border border-slate-150 transition-all">
      <Link to={editLink} className="responsive-flex-lg flex-1">
        <div className="flex flex-col flex-1 justify-between lg:pl-4 lg:pr-4">
          <div className="flex h-full gap-3">
            <div className="grid w-full gap-1 pt-3 lg:py-0">
              <div className="grid grid-flow-col items-center ">
                <div className="flex items-center gap-1 mb-1 text-xl">
                  <span className="font-bold text-primary leading-4">
                    {dayjs(item?.executionDate).format('DD/MM/YYYY')}
                  </span>
                </div>
                <div className="flex items-center gap-1 justify-end">
                  <Status status={item?.status} small />
                </div>
              </div>

              <div className="grid grid-flow-col items-center ">
                <div className="flex flex-row gap-2 items-center justify-start">
                  <div className="flex items-center gap-1 font-normal leading-1 text-center">
                    <div className="flex-1">{`${item?.description} du ${dayjs(
                      item?.effectiveStartDate
                    ).format('DD/MM/YYYY')} au ${dayjs(item?.effectiveEndDate).format(
                      'DD/MM/YYYY'
                    )}`}</div>
                  </div>
                </div>
              </div>
              <div className="flex flex-row gap-2 w-full items-center mt-1 self-end place-self-end justify-self-end">
                <span className="font-bold text-primary text-md">{item?.profile.username}</span>
                {' - '}
                <span className="font-bold text-primary text-sm">
                  {item?.profile.firstname} {item?.profile.lastname}
                </span>
                <ProfileBadges profile={item.profile} classname="" isSmall noText />
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default PaymentItem;
